import { useMemo } from 'react';

import generateImageSrc from '@glass/web/modules/images/generateImageSrc';

import getImageHeight from '@glass/shared/components/Image/helpers/getImageHeight';

const useSrc = ({
  width,
  seoTitle,
  path,
  origin,
  external = false,
  aspectRatio,
  height,
  fit,
  quality,
} = {}) =>
  useMemo(
    () =>
      generateImageSrc({
        width,
        height: height || getImageHeight(width, aspectRatio),
        seoTitle,
        path,
        origin,
        external,
        fit,
        quality,
      }),
    [width, height, aspectRatio, seoTitle, path, origin, external, fit, quality],
  );

export default useSrc;
